import { render, staticRenderFns } from "./course-outline-assessment.vue?vue&type=template&id=4cd1d28a&scoped=true&"
import script from "./course-outline-assessment.vue?vue&type=script&lang=js&"
export * from "./course-outline-assessment.vue?vue&type=script&lang=js&"
import style0 from "./course-outline-assessment.vue?vue&type=style&index=0&id=4cd1d28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd1d28a",
  null
  
)

export default component.exports